import {SpreadsheetPageData} from './SpreadsheetPageData';

export class SpreadsheetData {
    constructor(public Pages: SpreadsheetPageData[]) {
    }
}